import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN } from "../../lib/cookie";
import { getLatestPost } from "../../api/postAPI";

import styled from "styled-components";
import { Row, Col, Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { MainColor, SubColor } from "../../style/styleValue";
import { useLang } from "../../i18n";

const LatestSection = () => {
  const [post, setPost] = useState<any>(null);

  const navigate = useNavigate();
  const lang = useLang();

  const handlePostClick = (postId: number) => {
    const hasToken = !!localStorage.getItem(ACCESS_TOKEN);

    if (hasToken) {
      navigate(`/post/${postId}`);
    } else {
      alert(lang === 'en' ? "Please log in to view this case." : "해당 게시물은 로그인 후 열람 가능합니다.");
    }
  };

  useEffect(() => {
    getLatestPost().then(data => {
      if (data) {
        setPost(data);
      }
    });
  }, []);

  return (
    <BottomContainer>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={16}>
          <SectionHeader>
            <div className="left-group">
              <h2 className="section-label">Latest Updates</h2>
            </div>
          </SectionHeader>

          {post &&
          <UpdateCard>
            <ImageWrapper>
              <img
                src={
                  post.postThumbnail ?
                  `${process.env.REACT_APP_BACKEND_URL}/api/photo/${post.postThumbnail}` :
                  "/img/sample_thumbnail/sample.png"}
                alt={post.title} />
              <GradientOverlay />
            </ImageWrapper>
            <ContentLayer>
              <CardTitle>{post.title}</CardTitle>
              <ViewButton type="primary" onClick={() => handlePostClick(post.id)}>
                View Case <ArrowRightOutlined />
              </ViewButton>
            </ContentLayer>
          </UpdateCard>}
        </Col>

        <Col xs={24} lg={8}>
          <PosterCard>
            <div className="poster-content">
              <img src="/img/samplephoto.live" alt="Photo" />
            </div>
          </PosterCard>
        </Col>
      </Row>
    </BottomContainer>
  );
};

const BottomContainer = styled.div`
  max-width: 1200px;
  margin: 100px 0;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  height: 32px;

  .left-group {
    display: flex;
    align-items: center;
  }

  .section-label {
    font-size: 1.2rem;
    color: #333;
    margin: 0;
  }
`;

const UpdateCard = styled.div`
  position: relative;
  display: flex !important;
  align-items: center;
  height: 230px; 
  background: #fff;
  border-radius: 4px;
  border: 1px solid #f0f2f5;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  img { width: 100%; height: 100%; object-fit: cover; filter: saturate(2.5) contrast(1.05) brightness(1); }
`;

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right, 
    rgba(255, 255, 255, 0) 0%, 
    rgba(255, 255, 255, 0) 40%, 
    rgba(255, 255, 255, 1) 90%
  );
`;

const ContentLayer = styled.div`
  position: relative;
  z-index: 2;
  margin-left: auto;
  width: 55%;
  padding: 20px 30px;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  color: #000;
  margin-bottom: 2rem;
`;

const ViewButton = styled(Button)`
  width: fit-content;
  height: 32px;
  padding: 0 20px;
  border-radius: 6px;
  background-color: ${SubColor} !important;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background-color: ${MainColor} !important;
  }
`;

const PosterCard = styled.div`
  height: 230px;
  border-radius: 4px;
  margin-top: 47px; 
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  img { width: 100%; height: 100%; object-fit: cover; }
`;

export default LatestSection;